import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export function useCouponRoute(coupons) {
    const { dynamicPath, couponId } = useParams();
    const navigate = useNavigate();
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Abre o modal automaticamente se tiver couponId na URL
    useEffect(() => {
        if (!couponId || !coupons?.data) return;
        const coupon = coupons.data.find(c => String(c.id) === couponId);
        if (coupon) {
        setSelectedCoupon(coupon);
        setIsModalOpen(true);
        }
    }, [couponId, coupons]);

    const openCoupon = (coupon) => {
        if (!coupon) return;
        navigate(`/${dynamicPath}/${coupon.id}`, { replace: true });
        setSelectedCoupon(coupon);
        setIsModalOpen(true);
    };


    const closeCoupon = () => {
        navigate(`/${dynamicPath}`, { replace: true });
        setSelectedCoupon(null);
        setIsModalOpen(false);
    };

    return {selectedCoupon, isModalOpen, openCoupon, closeCoupon};
}
